import { render, staticRenderFns } from "./studioDashboardDaycare.vue?vue&type=template&id=c6a70518&scoped=true"
import script from "./studioDashboardDaycare.vue?vue&type=script&lang=js"
export * from "./studioDashboardDaycare.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardDaycare.vue?vue&type=style&index=0&id=c6a70518&prod&lang=scss&scoped=true"
import style1 from "./studioDashboardDaycare.vue?vue&type=style&index=1&id=c6a70518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a70518",
  null
  
)

export default component.exports